import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getCanceledRepeatedScheduledRidesDueToMembership = async (callerId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
    },
    query: graphql(`
      query GetCanceledRepeatedScheduledRidesDueToMembership($callerId: String!) {
        getCanceledRepeatedScheduledRidesDueToMembership(callerId: $callerId) {
          id
        }
      }
    `),
  });

  return response.data.getCanceledRepeatedScheduledRidesDueToMembership;
};
